import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useConsent } from '../../context/ConsentContext';
import { ConsentState } from '../../utils/gtag';
import '../../styles/consent.css';

interface Props {
  onClose: () => void;
}

const ConsentModal: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation('consent');
  const { consent, updateConsent } = useConsent();
  const [local, setLocal] = useState<ConsentState>({ ...consent });

  const toggle = (key: keyof ConsentState) => {
    setLocal(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const save = () => {
    updateConsent(local);
    onClose();
  };

  return (
    <div className="consent-modal-overlay" onClick={onClose}>
      <div className="consent-modal" onClick={e => e.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="consent-modal-title">
        <h2 className="consent-modal__title" id="consent-modal-title">{t('modal.title')}</h2>
        <p className="consent-modal__subtitle">{t('modal.subtitle')}</p>
        <div className="consent-modal__categories">
          {/* Essential — always on, no toggle */}
          <div className="consent-category">
            <div className="consent-category__info">
              <p className="consent-category__name">{t('categories.essential.name')}</p>
              <p className="consent-category__desc">{t('categories.essential.desc')}</p>
            </div>
            <label className="consent-toggle">
              <input type="checkbox" checked disabled />
              <span className="consent-toggle__track" />
            </label>
          </div>

          <div className="consent-category">
            <div className="consent-category__info">
              <p className="consent-category__name">{t('categories.analytics.name')}</p>
              <p className="consent-category__desc">{t('categories.analytics.desc')}</p>
            </div>
            <label className="consent-toggle">
              <input type="checkbox" checked={local.analytics} onChange={() => toggle('analytics')} />
              <span className="consent-toggle__track" />
            </label>
          </div>

          <div className="consent-category">
            <div className="consent-category__info">
              <p className="consent-category__name">{t('categories.marketing.name')}</p>
              <p className="consent-category__desc">{t('categories.marketing.desc')}</p>
            </div>
            <label className="consent-toggle">
              <input type="checkbox" checked={local.marketing} onChange={() => toggle('marketing')} />
              <span className="consent-toggle__track" />
            </label>
          </div>

          <div className="consent-category">
            <div className="consent-category__info">
              <p className="consent-category__name">{t('categories.preferences.name')}</p>
              <p className="consent-category__desc">{t('categories.preferences.desc')}</p>
            </div>
            <label className="consent-toggle">
              <input type="checkbox" checked={local.preferences} onChange={() => toggle('preferences')} />
              <span className="consent-toggle__track" />
            </label>
          </div>
        </div>

        <button className="consent-modal__save" onClick={save}>{t('modal.save')}</button>
      </div>
    </div>
  );
};

export default ConsentModal;
